namespace TabAurous.Production {
    export interface JobWorkIssueRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        PartyId?: number;
        LedgerName?: string;
        DepartmentId?: number;
        UserId?: number;
        Username?: string;
        EmployeeId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        ItemDetails?: JobWorkIssueItemsRow[];
    }

    export namespace JobWorkIssueRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.JobWorkIssue';
        export const deletePermission = 'Production:JobWorkIssue:Delete';
        export const insertPermission = 'Production:JobWorkIssue:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:JobWorkIssue:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            DepartmentId = "DepartmentId",
            UserId = "UserId",
            Username = "Username",
            EmployeeId = "EmployeeId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            ItemDetails = "ItemDetails"
        }
    }
}
